import { RootState } from 'store/rootReducer';

export const GenericErrorPageContentSelector = (state: RootState) => state.content.genericError;
